// src/contexts/CurrencyContext.js
import { createContext, useContext, useState } from 'react';

const CurrencyContext = createContext();

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return context;
};

export const CurrencyProvider = ({ children }) => {
  const [selectedCurrency, setSelectedCurrency] = useState({
    code: 'USD',
    symbol: '$',
    label: 'USD'
  });

  const currencies = [
    { code: 'USD', symbol: '$', label: 'USD' },
    { code: 'AED', symbol: 'AED', label: 'AED' }
  ];

  const changeCurrency = (currency) => {
    setSelectedCurrency(currency);
    // You can add additional logic here like API calls, localStorage, etc.
  };

  const value = {
    selectedCurrency,
    currencies,
    changeCurrency
  };

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};